import { AccessRule } from './types';

/**
 * Named, shared access rules — evaluated via `canAccess` (e.g. through the
 * `useCanAccessMealPlan` hook). Both the sidebar registry (`config.ts`) and
 * feature surfaces (e.g. the workout-plan meal-plan widget) reference these so
 * they cannot disagree about who may see a feature. Never re-derive a rule from
 * raw `features`/flags at the call site.
 */

/** Gate for nutrition / meal-plan visibility (sidebar entry + workout-plan widget). */
export const MEAL_PLAN_ACCESS: AccessRule = {
    account: 'paid',
    feature: ['nutrition_meal_suggestion'],
    flag: [
        {
            key: 'mb-portal-nutrition-plans',
            type: 'json',
            predicate: (value) =>
                Boolean((value as { show_meal_plan_card_on_plan?: boolean })?.show_meal_plan_card_on_plan),
        },
        {
            key: 'mb_nutrition_plan',
            type: 'json',
            predicate: (value) =>
                Boolean((value as { show_meal_plan_card_on_plan?: boolean })?.show_meal_plan_card_on_plan),
        },
    ],
};
